export * from './quadratic.model';
export * from './quadratic.creator';
